var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';
import HdTag from '../hd-tag';
import { StyledSelect } from './styles';
const renderTag = (tag, theme) => {
    return (_jsx(HdTag, { text: tag.label, color: theme.colors.purple_2, onClose: tag.closable ? tag.onClose : undefined, size: "small", onClick: tag.onClose, hoverable: tag.closable }));
};
const Select = (_a) => {
    var props = __rest(_a, []);
    const theme = useTheme();
    const tagRender = useCallback((tag) => renderTag(tag, theme), [theme]);
    const suffixIcon = useMemo(() => _jsx(TabArrow, { size: 12, down: true, color: theme.colors.grey_2 }), [theme.colors.grey_2]);
    return (_jsx(StyledSelect, Object.assign({}, props, { className: ['notranslate', props.className].filter(Boolean).join(' '), "$noPadding": props.noPadding, tagRender: tagRender, suffixIcon: suffixIcon })));
};
export default Select;
